import React from 'react';
import { Loader, BaasicTable, TableFilter, BaasicHeader, BaasicTableExport } from 'core/components';
import { PickingBatchListDetail } from 'modules/picking-batch/pages';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';
import { PickingBatchStore } from 'modules/picking-batch/stores';
import { FileNames } from 'common/constants';

const PickingBatchListTemplate = ({
	t,
	actions,
	showActions,
	viewStore,
	viewStore: { loading, listStore, tableData, queryUtility, isExpand, onExpandChange, change, columnFilterSetup },
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.PICKINGBATCHES.TITLE">
				<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.PickingBatch} />
			</BaasicHeader>
			<div className="k-grid--expandable__cell fullheight">
				<BaasicTable
					{...{
						listStore,
						tableData,
						queryUtility,
						viewStore: viewStore,
						actions,
						detailComponent: PickingBatchListDetail,
						showActions,
						isExpand,
						change,
					}}
					data={listStore.data.slice()}
					expandChange={onExpandChange}
				/>
			</div>
			<ReactTooltip />
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
		</section>
	);
};
export default defaultTemplate(PickingBatchListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/picking-batch/pages/PickingBatchListTemplate.jsx